import { render, staticRenderFns } from "./AlertChart.html?vue&type=template&id=4c30408a&scoped=true&external"
import script from "./AlertChart.vue?vue&type=script&lang=js"
export * from "./AlertChart.vue?vue&type=script&lang=js"
import style0 from "./AlertChart.scss?vue&type=style&index=0&id=4c30408a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30408a",
  null
  
)

export default component.exports